import React from 'react';
import Highcharts from 'highcharts';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  width: 100% !important;
  margin-top:${({ isMargin }) => isMargin ? '' : '30px'};
  ${'' /* margin-top: 30px; */}
  height: 100%;
  .highcharts-crosshair-category {
    display: none !important;
    visibility: hidden !important;
  }
  .highcharts-container {
    width: 100% !important;
    ${'' /* width:${({ isGlucose }) => isGlucose ? '80%' : '100%'}!important; */}
    > svg {
      width: 100%;
    
      g{
     
        &:hover {
          fill:none
      }
      .hover {
        fill:none
    }
        text{
          text-transform: capitalize;
          font-size: 14px;
          font-family: 'Rubik';
          width:8px;
        }
        rect{
       
          ${'' /* width:${({width}) => width ? width : '50px'}; */}
          background-color: rgba(254,254,254,0.60);
          transform:"none",
        &:hover {
            fill:none
        }

        .highcharts-point{
            border-radius:30px;
        }
        .hover {
          fill:none
      }
        }




      }
    }
  }
`;

class VerticalBarChart extends React.Component {

  componentDidMount() {
    this.renderGraph(this.props);
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.renderGraph(this.props);
    }
  }

  renderGraph = (props) => {
    const {
      seriesData,
      xAxisLabel,
      yAxisTitle,
      xAxisTitle,
      title,
      fillColor,
      id,
      xAxisVisible,
      //   yAxisVisible,
      fontWeight,
      wellBeing,
      wellnessGoals,
      splineData
      //   circleColor,
      //   circleBorderColor,
    //   widthType
    } = props;
    const maxLimit = 100;
    const GraphData = [];
    const data = [...seriesData];
    
    data.map((series, index) => {
      series.stack = index;
      series.dataLabels = {
        color: wellBeing ? '#fff' : series.color,
        style: {
          textShadow: false,
          textOutline: false,
        },
      };
      GraphData.push({
        stack: index,
        data: [],
        showInLegend: false,
        dataLabels: { enabled: false },
        states: {
          hover: {
            enabled: false,
          },
        },
      });
      GraphData.map((fillSeries) => {
        if (fillSeries.stack === index) {
          series.data.map((value) => {
            fillSeries.data.push(maxLimit - value);
          });
          fillSeries.color = fillColor ? 'transparent' : 'rgba(12, 153, 193, 0.2)';
        }
      });
    });



    Highcharts.chart(id, {
      chart: {
        type: 'column',
        colorByPoint: true,
        className: 'top-circle',
        backgroundColor: 'transparent',
      },
      title: {
        text: title || null
      },
      credits: {
        enabled: false
      },
      xAxis: {
        minPadding: 10,
        categories: xAxisLabel,
        crosshair: wellnessGoals ? false : true,
        className: 'xAxis',
        // lineWidth: 0,
        // distance:1,
        // minorGridLineWidth: 0,
        // lineColor: 'transparent',
        minorTickLength: 0,
        tickLength: 0,
        visible: xAxisVisible,
        title: {
          text: xAxisTitle || null
        },
        labels: {
        //   x: widthType === "full" ? -30 : -37,
        //   useHTML: true, // Enables HTML rendering for the labels
          style: {
            color: '#184A61',
            fontFamily: 'Lato',
            fontSize: '16px',
            fontWeight: fontWeight ? 400 : 400,
            textTranform: 'capitalize'
          }
        }
      },
      yAxis: {
        // categories:yAxisVisible,
        min: 0,
        max: 100,
        minPadding: 0.4,  // Adds a gap at the bottom of the chart
        showEmpty: false,
        // tickInterval: 25,
        lineWidth: 0,
        minorGridLineWidth: 0,
        gridLineWidth:0,
        // lineColor: 'transparent',
        // gridLineColor: '#EFEFEF',
        // gridLineDashStyle: 'Dash', // Add dashed lines
        offset: 30,
        visible: false,
        labels: {
          formatter: function () {
            return this.value
          },
          style: {
            color: 'rgba(0, 92, 135, 0.60)',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: fontWeight ? 400 : 400,
            textTranform: 'capitalize'
          }
        },
        title: {
          text: yAxisTitle || null
        },
        states: {
          inactive: {
            opacity: 1,
            fill: 'transparent'
          }
        }},
      tooltip: {
        style: {
          fontFamily: wellnessGoals ? 'Rubik-Medium' : 'Rubik',
          fontSize: wellnessGoals ? '15px' : '11px',
          fontWeight: 500,
        },
        formatter: function () {
          return `${this.y}`;
        }
      },
      legends: {
        enabled: false
      },
      plotOptions: {
        // groupPadding: 0.1,
        shadow: false,
        column: {
          pointPadding: 0.1, // Adds spacing between the bar and X-axis
          groupPadding: 0.3, // Adjusts the space between groups of bars
          borderWidth: 0,
          borderRadius: 12, // Adjust this value to set the radius
          states: {
            hover: {
              enabled: false
            },
            inactive: {
              opacity: 1,
            }
          },
          dataLabels: {
            enabled: false,
            crop: false,
            overflow: 'none',
            verticalAlign: 'bottom',
            // top: '10%',
            inside: false,
            // y: -1,
            formatter: function () {
              return this.y > 9 ? this.y + '%' : ''
            },
            style: {
              fontFamily: wellnessGoals ? 'Rubik-Medium' : 'Rubik',
              fontSize: wellnessGoals ? '15px' : '11px',
              fontWeight: wellnessGoals ? 700 : 500,
            },
            pointPadding: 0,
          },
          animation: false
        },
        series: {
          stacking: 'normal'
        }
      },
      labelStyle: {
        fontSize: "8em",
      },
      series: [
        ...GraphData,
        ...data,
        splineData
      ],

    });
  };


  render() {
    const { id, wellnessGoals, width, isMargin} = this.props;
    return (
      <Container isMargin={isMargin} id={id} wellnessGoals={wellnessGoals} width={width || "50px"}/>
    )
  }
}

VerticalBarChart.defaultProps = {
  xAxisVisible: true,
  yAxisVisible: true,
  id: "chart"
}

VerticalBarChart.propTypes = {
  xAxisTitle: PropTypes.string,
  yAxisTitle: PropTypes.string,
  xAxisLabel: PropTypes.array,
  yAxisLabel: PropTypes.array,
  seriesData: PropTypes.array,
  yAxisVisible: PropTypes.bool,
  id: PropTypes.string,
  title: PropTypes.string,
  xAxisVisible: PropTypes.bool,
  wellBeing: PropTypes.number,
  wellnessGoals: PropTypes.number,
  width: PropTypes.string,
  isMargin: PropTypes.bool,
  circleColor: PropTypes.string,
  circleBorderColor: PropTypes.string,
  widthType:PropTypes.string,
  splineData:PropTypes.object
};

export default VerticalBarChart;